module.exports = __webpack_public_path__ + "static/img/07.57cf6c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/07.png
// module id = xHDX
// module chunks = 1